import React, { useState} from "react";
import {Grid} from '@mui/material';

import Toolbar from '@mui/material/Toolbar';
import Card from "@mui/material/Card";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate } from 'react-router-dom';


import MDBox from './MDBox/MDBoxRoot';

import { useScreenSize } from "../hooks/ScreenSizeContext";
import Registrations from "./ReportRegistrations";
import Purchases from "./ReportPurchases";
import InstructorEventsReport from "./ReportInstructorEvents";
import ReportEvents from "./ReportEvents";


export default function EditEvent() {

  const isSmallScreen = useScreenSize();

  const [valueTab, setValueTab] = useState('1');
  const navigate = useNavigate();

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValueTab(newValue);
  };

  return (
    <Card>
      <MDBox
        component="main" px={2} py={3}
        sx={{ flexGrow: 1, width: '100%' }}
      >
        <Toolbar />

          <Grid item xs={9} sx={{ marginTop: "10px" }}>
            <TabContext value={valueTab}>
            <Tabs
              value={valueTab}
              onChange={handleChangeTab}
              textColor="primary"
              aria-label="Reports"
              variant="scrollable"
              scrollButtons= "auto"
              allowScrollButtonsMobile= {true}
            >

                <Tab label="Registrations" value="1" /> 
                <Tab label="Purchases" value="2" />
                <Tab label="Instructor Schedule" value="3" />
                <Tab label="Events" value="4" />
              </Tabs>

              <TabPanel value="1" sx={{paddingLeft:'8px', paddingRight:'8px'}}><Registrations/></TabPanel>
              <TabPanel value="2"><Purchases/></TabPanel>
              <TabPanel value="3"><InstructorEventsReport/></TabPanel>
              <TabPanel value="4"><ReportEvents/></TabPanel>
            </TabContext>
          </Grid>

      </MDBox>
    </Card>
  )
}



